module.exports = __webpack_public_path__ + "img/part_time_recruitment.d5a6e11.png";